import { type InputHTMLAttributes, forwardRef } from "react";
import { cn } from "../../lib/utils.ts";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, ...props }, ref) => {
    return (
      <div className="w-full space-y-1.5">
        {label && (
          <label className="text-xs font-bold uppercase tracking-widest text-heritage-walnut/60">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={cn(
            "flex w-full rounded-xl border border-heritage-linen bg-white px-4 py-4 text-base transition-all",
            "placeholder:text-heritage-walnut/30",
            "focus:border-heritage-sage focus:outline-none focus:ring-4 focus:ring-heritage-sage/5",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-error focus:ring-error/5",
            className,
          )}
          {...props}
        />
        {error && <p className="text-xs font-medium text-error">{error}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";
